import ResizableScene from "../core/ResizableScene";

export default class Overlay {
    static create(scene: ResizableScene, alpha = 0.8): Phaser.GameObjects.Sprite {
        const overlay = scene.add.sprite(0, 0, "whiteSquare");
        overlay.setSize(scene.viewport.width, scene.viewport.height);
        overlay.setDisplaySize(scene.viewport.width, scene.viewport.height);
        overlay.tint = 0x000000;
        overlay.alpha = alpha;
        scene.input.enable(overlay);

        return overlay;
    }
}
